import type { GlbConversionEligibilityReport } from 'glb-usdz-converter/core/types'

export type GalleryApiErrorData = {
  message?: string
  statusMessage?: string
  bundle_ids?: string[]
  data?: { bundle_ids?: string[] }
  glb_conversion_report?: GlbConversionEligibilityReport
}

export async function $galleryApi<T>(
  request: Parameters<typeof $fetch<T>>[0],
  opts?: Parameters<typeof $fetch<T>>[1],
) {
  const currentUser = useCurrentUser()
  const token = await currentUser.value?.getIdToken()

  return $fetch<T>(request, {
    ...opts,
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
      ...opts?.headers,
    },
  })
}

export const getGalleryApiErrorData = (error: unknown): GalleryApiErrorData => {
  const err = error as {
    data?: GalleryApiErrorData
  }

  return err?.data ?? {}
}

export const getGalleryApiErrorMessage = (
  error: unknown,
  fallbackMessage: string,
) => {
  const err = error as {
    data?: GalleryApiErrorData
    message?: string
    statusMessage?: string
  }

  const baseMessage =
    err?.data?.message ??
    err?.data?.statusMessage ??
    err?.statusMessage ??
    err?.message ??
    fallbackMessage

  const bundleIds = err?.data?.bundle_ids ?? err?.data?.data?.bundle_ids ?? null

  if (bundleIds?.length) {
    return `${baseMessage} (invalid bundles: ${bundleIds.join(', ')})`
  }

  return baseMessage
}
